/** UI-only notice: never include this message in generated report content. */
export function getReportRealNamesWarning(
  reportId: string | null | undefined,
  ntpDisplayMode: unknown,
  showSuppressedAgents: unknown,
): string | null {
  const showsNtpNames = ntpDisplayMode === 'general_list';
  switch (reportId) {
    case 'mga_paid':
    case 'mga_submit':
      return showsNtpNames ? 'NTP agencies are displayed under their real names.' : null;
    case 'personal_paid':
    case 'personal_submit':
      return showsNtpNames || showSuppressedAgents === true || showSuppressedAgents === 'true'
        ? 'NTP / Suppressed agents are displayed under their real names.'
        : null;
    default:
      return null;
  }
}
